<template>
  <div>
    <ul>
      <li v-for="item in options" v-if="item.isdelete === 0" @click="goList(item)">
        <van-image :src="item.image.url">
          <template v-slot:loading>
            <van-loading type="spinner" size="20"/>
          </template>
        </van-image>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "catalog",
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    goList(item) {
      if (item.image.activity === 1000000) {
        this.$router.push({path: `/academicTools`})
      } else {
        if (item.image.relevance) {
          this.$router.push({path: `/contentList/${item.image.activity}/${item.image.activity}.${item.image.catalog}.${item.id}`})
        } else {
          this.$router.push({path: `/contentList/${item.image.activity}`})
        }
      }
    },
    getList() {
      let api = this.$api.ml.catalog
      switch (this.$route.params.type) {
        case '1':
          api = this.$api.ml.catalog
          break
        case '2':
          api = this.$api.ml.catalog2
          break
        case '3':
          api = this.$api.ml.catalog3
          break
        case '4':
          api = this.$api.ml.catalog4
          break
        case '5':
          api = this.$api.ml.catalog5
          break
      }
      this.$http.get(api).then(res => {
        res.data.forEach(item => {
          item.image = JSON.parse(item.image)
        })
        this.options = res.data
      })
    },
  }
}
</script>

<style lang="scss" scoped>
ul {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 40px 24px;

  li {
    margin-bottom: 40px;
  }
}
</style>
